// extracted by mini-css-extract-plugin
module.exports = {"img":"_0fce717cdb--img--_7hry","footer":"_0fce717cdb--footer--o2LMh"};